import { SvgIcon, Typography } from "@mui/material";

import { ThermometerIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { StatCard } from "../components/StatCard";

type MovementCardProps = {
  temperature: string | null;
};

export function TemperatureCard({ temperature }: MovementCardProps) {
  const { t } = useTranslation();

  if (!temperature) {
    return null;
  }

  return (
    <StatCard>
      <SvgIcon component={ThermometerIcon} color={"neutral.decoration"} />
      <Typography
        variant={"bodySmallMedium"}
        sx={{
          color: "neutral.subtle",
        }}
      >
        {t("Temperature")}
      </Typography>
      <Typography variant={"headingLargeRegular"}>{temperature}°C</Typography>
    </StatCard>
  );
}
